import * as consts from './GalleryConsts';
import { getStageByImage } from '../helpers/floorplanUtils/utils';
import { changeStage } from '../floorplan/FloorplanActions';
import { getGalleryRequest } from '../helpers/requestUtils';

export const setActiveSlide = (name) => {
    return (dispatch, getState) => {
        const visitedSlides = new Set(getState().gallery.visitedSlides);
        if (name.length) {
            visitedSlides.add(name);
        }

        const stages = getState().floorplan.stages;
        const activeStage = getState().floorplan.activeStage;

        const imageFloor = getStageByImage(stages, name);
        if (imageFloor && (imageFloor.name !== stages[activeStage].name)) {

            if (activeStage !== stages.indexOf(imageFloor)) {
                dispatch(changeStage(stages.indexOf(imageFloor)));
            }
        }

        dispatch({
            type: consts.SET_ACTIVE_SLIDER,
            payload: {
                activeSlideName: name,
                visitedSlides
            }
        })
    }
}

export const toggleVisibility = () => {
    return dispatch => {
        dispatch({
            type: consts.TOGGLE_VISIBILITY
        })
    }
}


export const getGallery = () => {
    return (dispatch, getState) => {
        const tourId = getState().app.tourId;
        const tourType = getState().app.tourType;
        dispatch({ type: consts.GET_GALLERY_PENDING });
        getGalleryRequest(tourId, tourType).then(data => {
            if (data.Error.length) {
                dispatch({ type: consts.GET_GALLERY_REJECTED });
            } else {
                const name = !!+data.data.images.length
                    ? data.data.images[0].file_name
                    : '';
                dispatch({
                    type: consts.GET_GALLERY_FULFILLED,
                    payload: {
                        gallery: data.data,
                    }
                });
                dispatch(setActiveSlide(name));
            }
        }, () => {
            dispatch({type: consts.GET_GALLERY_REJECTED});
        });
    }
}
